import VueRouter from 'vue-router'
import DetailsView from '../components/details/DetailsView.vue'
import MapView from '../components/map/MapView.vue'

const router = new VueRouter({
    base: decodeURI(window.TS_CONFIG.baseUrl),
    mode: 'history', //this disables the hashbang (#) routing
    fallback: false, //no backwards compatibility for old browsers
    routes: [
        {
            path: '/',
            component: MapView
        },
        {
            path: '/:detailsurl',
            component: DetailsView
        }
    ]
});
export default router;